import { AuditAction, AuditModule } from '../enums/audit-trail.enum';
import { OptionDescription } from '../types/option.type';
import { RECORD_TYPES_CONFIG } from "./audit-trail-config.data";
import { RECORD_TYPES_DCDD, RECORD_TYPES_ECDD } from "./audit-trail-ecdd.data";
import { RECORD_TYPES_FINANCE } from "./audit-trail-finance.data";
import { RECORD_TYPES_HRM } from "./audit-trail-hrm.data";
import { RECORD_TYPES_TRANCACTION } from "./audit-trail-transaction.data";

export type AuditTrailSearchMethod = 'searchHrm' | 'searchTransaction' | 'searchFinance' | 'searchConfiguration' | 'searchDcdd';

export const generalFieldsHide = ['businessUnitId'];
export const AUDIT_MODULE_DATA: Record<AuditModule, OptionDescription<AuditModule>> = {
  [AuditModule.Configuration]: {
    id: AuditModule.Configuration,
    value: AuditModule.Configuration,
    viewValue: 'Configuration',
    recordTypes: RECORD_TYPES_CONFIG,
  },
  [AuditModule.Transaction]: {
    id: AuditModule.Transaction,
    value: AuditModule.Transaction,
    viewValue: 'Transaction',
    recordTypes: RECORD_TYPES_TRANCACTION,
  },
  [AuditModule.Finance]: {
    id: AuditModule.Finance,
    value: AuditModule.Finance,
    viewValue: 'Finance',
    recordTypes: RECORD_TYPES_FINANCE,
  },
  [AuditModule.HumanResources]: {
    id: AuditModule.HumanResources,
    value: AuditModule.HumanResources,
    viewValue: 'Human Resources',
    recordTypes: RECORD_TYPES_HRM,
  },
  [AuditModule.ECDD]: {
    id: AuditModule.ECDD,
    value: AuditModule.ECDD,
    viewValue: 'ECDD',
    recordTypes: RECORD_TYPES_ECDD
  },
  [AuditModule.DCDD]: {
    id: AuditModule.DCDD,
    value: AuditModule.DCDD,
    viewValue: 'DCDD',
    recordTypes: RECORD_TYPES_DCDD
  },
};


export const AuditActions = [
  {
    id: AuditAction.CREATE,
    name: AuditAction.CREATE,
  },
  {
    id: AuditAction.UPDATE,
    name: AuditAction.UPDATE,
  },
  {
    id: AuditAction.DELETE,
    name: AuditAction.DELETE,
  },
  {
    id: AuditAction.PAY,
    name: AuditAction.PAY,
    isFinance: true,
  },
  {
    id: AuditAction.REVERSE,
    name: 'REVERSE PAYMENT',
    isFinance: true,
  },
  {
    id: AuditAction.SENDMAIL,
    name: 'SEND EMAIL',
    isFinance: true,
  },
]

